<router-outlet>
    <ngx-spinner type="ball-spin-clockwise" [zIndex]="9999999999999"></ngx-spinner>
    <p-confirmDialog #cd header="{{'_notification_' | translate}}"  [baseZIndex]="9999999999"  icon="pi pi-exclamation-triangle" [transitionOptions]="'0ms'">
        <p-footer>
            <button type="button" pButton icon="pi pi-check" label="{{'_accept_' | translate}}" (click)="cd.accept()"></button>
            <button type="button" class="p-button-secondary btn-cancel" pButton icon="pi pi-times" label="{{'_abort_' | translate}}" (click)="cd.reject()"></button>
        </p-footer>
    </p-confirmDialog>
    <p-toast position="top-right"  [baseZIndex]="999999999999"></p-toast>
</router-outlet>